import apis from '../../service/apis/invoice'
import { formatRequestData, download } from '../../plugins/helper'
import { Message } from 'element-ui'
// getInvoiceApplyRecords,
// getGroupCanInvoiceInfo,
// getInvoiceTitleList,
// getGroupRecentEmail,
// applyInvoice
export const invoice = {
  namespaced: true,
  state: {
    'canInvoiceAmount': 0, // 可开票金额
    'invoicedAmount': 0, // 已开票金额
    'rechargeAmount': 0, // 累计充值金额
    'refundAmount': 0, // 累计退款金额
    'canFreeDutyInvoiceAmount':0, //可开免税发票金额
    'canDutyInvoiceAmount':0, //可开含税发票金额
    'invoiceTitleList': [], // 发票列表
    'lastPhone': '', // 上一次开票的手机号
    'lastEmail': '', // 上一次开票的邮箱
    'applyInvoiceSuccess': false,
    'invoiceApplyRecords': [], // 组发票申请列表
    'RecordsTotal': 0,
    'tableLoading': false,
    'invoiceFlag':true //判断免税发票金额是否大于0  true:大于0
  },
  mutations: {
    getGroupCanInvoiceInfoSuccess (state, payload) {
      if (payload.res.data && Object.keys(payload.res.data).length > 0) {
        state.canInvoiceAmount = payload.res.data.canInvoiceAmount || 0
        state.invoicedAmount = payload.res.data.invoicedAmount || 0
        state.rechargeAmount = payload.res.data.rechargeAmount || 0
        state.refundAmount = payload.res.data.refundAmount || 0
        state.canFreeDutyInvoiceAmount = payload.res.data.canFreeDutyInvoiceAmount || 0
        state.canDutyInvoiceAmount = payload.res.data.canDutyInvoiceAmount || 0
        if (payload.isOldGroup) {
          //旧工作台
          if (state.canFreeDutyInvoiceAmount == 0) {
            state.invoiceFlag = false
          }else{
            state.invoiceFlag = true
          }
        } else {
          //新工作台
          state.invoiceFlag = false
        }
        
      }
    },
    getInvoiceTitleListSuccess (state, payload) {
      if (payload.res.data && Object.keys(payload.res.data).length > 0) {
        state.invoiceTitleList = payload.res.data
      }
    },
    getGroupRecentEmailSuccess (state, payload) {
      if (payload.res.data && Object.keys(payload.res.data).length > 0) {
        state.lastPhone = payload.res.data.phone
        state.lastEmail = payload.res.data.email
      }
    },
    applyInvoiceSuccess (state, payload) {
      state.applyInvoiceSuccess = !payload.res.status
    },
    getInvoiceApplyRecordsSuccess (state, payload) {
      if (payload.res.data && Object.keys(payload.res.data).length > 0) {
        state.invoiceApplyRecords = payload.res.data.dataList
        state.RecordsTotal = payload.res.data.total
        state.tableLoading = false
      }
    },
    openLoading (state) {
      state.tableLoading = true
    },
    resetState (state, payload) {
      state.lastPhone = ''
      state.lastEmail = ''
      state.invoiceTitleList = []
    },
    resetInvoiceTitleList (state, payload) {
      state.invoiceTitleList = []
    }
  },
  actions: {
    getGroupCanInvoiceInfo ({ commit ,dispatch ,rootState}, params) {
      // console.log('rootState',rootState.header.selfGroup)
      let isOldGroup = rootState.header.selfGroup.version == 1 ? false : true
      apis.getGroupCanInvoiceInfo(params).then(res => {
        commit('getGroupCanInvoiceInfoSuccess', {
          res,
          isOldGroup
        })
      })
    },
    getInvoiceTitleList ({ commit }, params) {
      apis.getInvoiceTitleList(params).then(res => {
        commit('getInvoiceTitleListSuccess', {res})
      })
    },
    getGroupRecentEmail ({ commit }, params) {
      apis.getGroupRecentEmail(params).then(res => {
        commit('getGroupRecentEmailSuccess', {res})
      })
    },
    getInvoiceApplyRecords ({ commit }, params) {
      apis.getInvoiceApplyRecords(params).then(res => {
        commit('getInvoiceApplyRecordsSuccess', {res})
      })
    },
    applyInvoice ({commit}, params) {
      apis.applyInvoice(params).then(res => {
        console.log(res)
        commit('applyInvoiceSuccess', {res})
      })
    },
    async downloadInvoice ({ commit, state }, data) {
      try {
        let requestData = formatRequestData(data)
        download('/eos/coupon/invoice/downloadInvoice', requestData, '发券失败手机号.xls')
      } catch (e) {
        console.log(e)
        Message.error('下载失败,请稍后在试')
      }
    }
  }
}
